<template>
  <div class="home-page">
    <div id="p5-container"></div>
    
    <div class="content" :style="{ opacity: overallOpacity }">
      <div class="uniswap-container">
        <iframe
          :src="`https://app.uniswap.org/#/swap?inputCurrency=ETH&outputCurrency=${contractAddress}&theme=dark`"
          height="100%"
          width="100%"
          style="
            border: 0;
            margin: 0 auto;
            border-radius: 16px;
            display: block;
            border: 1px solid var(--primary-color);
          "
        />
      </div>

      <div class="right-content">
        <div class="center-content">
          <div class="logo">
            <div class="logo-container">
              <img src="https://s2.loli.net/2025/01/15/D5pxKA2ObMcWNoT.png" alt="NOMADIQA" class="logo-image">
              <h1 class="logo-text">NOMADIQA</h1>
            </div>
          </div>
        </div>
        
        <div class="info-grid">
          <div class="info-item">
            <span class="label">PROJECT NAME</span>
            <span class="value">NOMADIQA</span>
          </div>
          <div class="info-item">
            <span class="label">TICKER NAME</span>
            <span class="value">NMDQ</span>
          </div>
          <div class="info-item">
            <span class="label">CONTRACT</span>
            <span class="value">{{ contractAddress }}</span>
          </div>
          <div class="info-item">
            <span class="label">TOTAL SUPPLY / CIRCULATING SUPPLY</span>
            <span class="value">1000,000000 / 2,000000</span>
          </div>
          <div class="info-item">
            <span class="label">KEYWORDS</span>
            <span class="value">#SOCIALFI #ERC-20 TOKEN</span>
          </div>
          <div class="info-item">
            <span class="label">COMMUNITY</span>
            <a href="https://www.google.com" target="_blank" class="value link">DISCORDIX</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { onMounted, ref } from 'vue'
import p5 from 'p5'

const userName = ref('NOMAD')
const contract = ref('0x65d75b5b4b87607860897755550e1a')
const community = ref('DISCORD ID')
const contractAddress = '0x66d28cb58487a7609877550e1a34691810a6b9fc'
const isFullyVisible = ref(false)

const overallOpacity = ref(0.1)
let timeoutId = null

// when mouse move, text opacity is 1, when mouse not move, text opacity is 0.3
const handleMouseMove = (e) => {
  overallOpacity.value = 1

  if (timeoutId) {
    clearTimeout(timeoutId)
  }

  timeoutId = setTimeout(() => {
    overallOpacity.value = 0.7
  }, 5000)
}

// when mouse click, the mask will be removed
const handleMouseClick = () => {
  overallOpacity.value = 1
  isFullyVisible.value = true

  setTimeout(() => {
    isFullyVisible.value = false
  }, 1000)
}

onMounted(() => {
  new p5(sketch, 'p5-container')
  window.addEventListener('mousemove', handleMouseMove)
  window.addEventListener('click', handleMouseClick)
})

const sketch = (p) => {
  let backgroundImage;
  let imageLoaded = false;
  let squareX = 0;
  let squareY = 0;
  let prevSquareX = 0;
  let prevSquareY = 0;
  let accelX = 0;
  let accelY = 0;
  let damping = 0.2;
  let applyFilter = false;
  let filterStartTime = 0;
  let frameSize = 0;
  let frameCenterX = 0;
  let frameCenterY = 0;
  let blinking = false;
  let lastBlinkTime = 0;
  let blinkInterval = 50;
  let showSquare = true;
  let blinkCount = 0;
  let maxBlinks = 15;

  const clickPositions = [{x: 0, y: 0}]

  p.preload = () => {
    let imageURL = 'https://s2.loli.net/2025/01/07/kZKgePTXvBSnc3M.jpg';
    backgroundImage = p.loadImage(imageURL, () => {
      imageLoaded = true;
      console.log('Image loaded successfully');
    }, () => {
      console.error('Failed to load image');
    });
  }

  p.setup = () => {
    console.log('Setup called, imageLoaded:', imageLoaded);
    p.createCanvas(p.windowWidth, p.windowHeight);
    // 添加黑色背景先，防止闪烁
    p.background(0);
  }

  p.windowResized = () => {
    p.resizeCanvas(p.windowWidth, p.windowHeight);
    if (imageLoaded && backgroundImage) {
      p.image(backgroundImage, 0, 0, p.width, p.height);
    }
  }

  p.draw = () => {
    if (!imageLoaded) {
      p.background(0);
      return
    }
  
    let targetX = p.mouseX;
    let targetY = p.mouseY;
    accelX = targetX - squareX;
    accelY = targetY - squareY;

    accelX *= damping;
    accelY *= damping;

    squareX += accelX;
    squareY += accelY;

    p.clear();

    p.background(0);

    if (isFullyVisible.value) {
      // show all
      p.image(backgroundImage, 0, 0, p.width, p.height);
    } else {
      p.push();
      const visibleRadius = 200;

      // soft glow effect
      const gradient = p.drawingContext.createRadialGradient(
        p.mouseX, p.mouseY, visibleRadius * 0.7, p.mouseX, p.mouseY, visibleRadius
      );
      gradient.addColorStop(0, 'rgba(0, 0, 0, 0)');
      gradient.addColorStop(1, 'rgba(0, 0, 0, 1)');

      // rounded mask
      p.drawingContext.save();
      p.drawingContext.beginPath();
      p.drawingContext.arc(p.mouseX, p.mouseY, visibleRadius, 0, p.PI * 2);
      p.drawingContext.clip();

      p.image(backgroundImage, 0, 0, p.width, p.height);

      // use gradient as fill
      p.drawingContext.fillStyle = gradient;
      p.drawingContext.fillRect(0, 0, p.width, p.height);

      p.drawingContext.restore();

      p.pop();
    }

    if (blinking) {
      if (p.millis() - lastBlinkTime > blinkInterval) {
        showSquare = !showSquare;
        lastBlinkTime = p.millis();
        blinkCount++;

        if (blinkCount >= maxBlinks) {
          blinking = false;
          showSquare = true;
        }
      }
    }

    p.push();
    // draw connected lines between click positions
    if (clickPositions.length > 1) {
      p.stroke(0, 255, 0);
      p.strokeWeight(1);
      p.noFill();
      p.beginShape();
      const lastPosition = clickPositions[clickPositions.length - 1]
      const lastSecondPosition = clickPositions[clickPositions.length - 2]
      p.vertex(lastPosition.x, lastPosition.y);
      p.vertex(lastSecondPosition.x, lastSecondPosition.y);
      p.endShape();
    }
    p.pop();

    if (showSquare) {
      p.noFill();
      p.stroke(255, 0, 0);
      p.rectMode(p.CENTER);
      p.rect(squareX, squareY, 50, 50);
    }

    p.stroke(255, 0, 0);
    p.line(0, p.mouseY, p.width, p.mouseY);
    p.line(p.mouseX, 0, p.mouseX, p.height);

    p.stroke(255, 0, 0, 100);
    p.rect(prevSquareX, prevSquareY, 50, 50);

    let lon = p.map(p.mouseX, 0, p.width, -180, 180);
    let lat = p.map(p.mouseY, 0, p.height, 90, -90);
    let lonDMS = decimalToDMS(lon, true);
    let latDMS = decimalToDMS(lat, false);
    
    p.fill(255, 0, 0, 100);
    p.textSize(12);

    p.push();
    p.translate(p.mouseX + 4, p.mouseY + 27);
    p.rotate(p.HALF_PI);


    // longitude text (vertical)
    let lonTextPosXOffset = 0
    let lonTextPosYOffset = 0

    // mouse move the right edge of the screen
    if (p.mouseX > p.width - 100) {
      lonTextPosYOffset = 20
    }

    // mouse move the bottom edge of the screen
    if (p.mouseY > p.height - 100) {
      lonTextPosXOffset = - 160
    }

    p.text("Lon: " + lonDMS, 0 + lonTextPosXOffset, 0 + lonTextPosYOffset);

    p.pop();

    // latitude text (horizontal)
    let latTextPosXOffset = 0
    let latTextPosYOffset = 0

    // mouse move the right edge of the screen
    if (p.mouseX > p.width - 100) {
      latTextPosXOffset = - 160
    }

    // mouse move the bottom edge of the screen
    if (p.mouseY < 100) {
      latTextPosYOffset = 20
    }

    p.text("Lat: " + latDMS, p.mouseX + 27 + latTextPosXOffset, p.mouseY - 4 + latTextPosYOffset);

    prevSquareX = squareX;
    prevSquareY = squareY;

    if (applyFilter) {
      let img = p.get(frameCenterX - frameSize / 2, frameCenterY - frameSize / 2, frameSize, frameSize);
      img.filter(p.INVERT);
      p.image(img, frameCenterX - frameSize / 2, frameCenterY - frameSize / 2);
      
      if (p.millis() - filterStartTime > 1000) {
        applyFilter = false;
      }
    }
  }

  p.mousePressed = () => {
    applyFilter = true;
    filterStartTime = p.millis();
    frameCenterX = p.mouseX;
    frameCenterY = p.mouseY;
    frameSize = 50;

    blinking = true;
    lastBlinkTime = p.millis();
    blinkCount = 0;

    clickPositions.push({
      x: p.mouseX,
      y: p.mouseY
    })
  }

  p.mouseReleased = () => {
    applyFilter = false;
  }

  function decimalToDMS(decimal, isLongitude) {
    let dir = isLongitude ? (decimal >= 0 ? "E" : "W") : (decimal >= 0 ? "N" : "S");
    decimal = Math.abs(decimal);
    let degrees = Math.floor(decimal);
    let minutes = Math.floor((decimal - degrees) * 60);
    let seconds = ((decimal - degrees - minutes / 60) * 3600).toFixed(0);
    return degrees + "° " + minutes + "' " + seconds + '" ' + dir;
  }
}
</script>

<style scoped>
@import './HomePage.css';
</style>
